import i18n from "i18n";

const data = {
  initialOrder: {
    destination: "",
    type: "REC",
  },
  headerOptions: [],
  steps: [
    {
      id: "0",
      name: i18n.t("step.description"),
    },
    {
      id: "1",
      name: i18n.t("products"),
    },
    {
      id: "2",
      name: i18n.t("locations"),
    },
    {
      id: "3",
      name: i18n.t("confirmation"),
    },

  ],
};

export default data;
